import React, { Component } from "react";
import PropTypes from "prop-types";
import Moment from 'moment';
import {_getBillingHistory} from "../../../../../../services/apis/AdminServices";

class BillingHistory extends Component {
    state = {
        billingHistory: [],
        error: ''
    }

    componentDidMount() {
        this._fetchBillingHistory();
    }

    _fetchBillingHistory = () => {
        const {userId} = this.props;

        _getBillingHistory(userId)
            .then(result => {
                const {success, data, message} = result;

                if (success) {
                    this.setState({
                        billingHistory: data,
                        error: ''
                    });
                } else {
                    this.setState({
                        error: message
                    });
                }
            }).catch(err => {
                this.setState({
                    error: err.message
                });
            });
    }

    render() {
        const { billingHistory, error } = this.state;

        if (!!error) {
            return (
                <div className="BillingHistoryError">{error}</div>
            );
        }

        return (
            <div className="BillingHistory">
                <table>
                    <thead>
                        <tr>
                            <th>Date</th>
                            <th>Description</th>
                            <th>Method</th>
                            <th>Amount</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            billingHistory.map((bill, index) => {
                                const { coupon, created, currency, price, method, title, updated } = bill;
                                const timeHistory = updated || created;
                                const total = (price + 0).toFixed(2);
                                const timeHistoryFormat = Moment(timeHistory).format('hh:mm:ss A, DD/MM/YYYY');

                                return (
                                    <tr key={index}>
                                        <td>
                                            <span>{timeHistoryFormat}</span>
                                        </td>
                                        <td className="Name">
                                            <span className="Text">{title}</span>
                                            {
                                                !!coupon &&
                                                <span className="Coupon">{coupon}</span>
                                            }
                                        </td>
                                        <td className="Method">{method}</td>
                                        {
                                            !!price
                                                ? <td className="Price">{total} {currency}</td>
                                                :
                                                <td className="Price">Free</td>
                                        }
                                    </tr>
                                );
                            })
                        }
                    </tbody>
                </table>
            </div>
        );
    }
}

BillingHistory.propTypes = {
    billingHistory: PropTypes.object.isRequired
};

export default BillingHistory;


// WEBPACK FOOTER //
// ./src/app/pages/dashboard/user/UserPage/components/BillingHistory.js